<template>
	<div>
		<div class="xqlist">
			   <figure style="width:100%; text-align:center;padding-top:50px;" v-if="list.length==0">
				   <img src="@/assets/kong.png" alt="" srcset="" />
				   <figcaption>暂无数据</figcaption>
			   </figure>
			   <div class="liebiao1" v-for="(item, index) in list" :key="item.d_id || index">
					<div class="title" @click="datails(item.d_id)">
						<h4 class="titleh4">{{item.name}}</h4>
						<span v-if="item.status==1" style="color:#1E3A8A;">报价中</span>
						<span v-if="item.status==2" style="color:#4DC800;">已结束</span>
						<span v-if="item.status==0" style="color:#E7AA00;">审核中</span>
						<span v-if="item.status==-1" style="color:#FF0000;">已驳回</span>
					</div>
					<div class="titleTiem" @click="datails(item.d_id)">
						<img src="@/assets/tiem.png" alt="" srcset="" />
						<span>发布时间：{{item.create_time}}</span>
					</div>
					<div class="hylist">
						<div>
							<div v-for="(i,index) in item.industries" :key="index" >{{i}}</div>
						</div>
					</div>
					<div class="hybox" @click="datails(item.d_id)">
						<span>{{item.description}}</span>
					</div>
					<div class="hyfooter" v-if="item.status==1">
                        <div class="hyfooter1" @click.stop="XQbj(item.d_id)"  v-if="item.invite_status !=1">邀请投标</div>
						<div class="hyfooter2" :class="{'kandu':item.invite_status ==1}" @click="datails(item.d_id)">
							查看报价 {{item.quotes_count || '0'}} / {{item.quote_num}}
						</div>
					</div>
					<div class="hyfooter" v-if="item.status==2 && item.q_id==0 && item.quotes_count>0 && item.is_off==0 && item.end_text==5">
					    <div class="hyfooter2"  @click="Addemand(item.d_id,'2')">再次发布</div>
					    <div class="hyfooter1" @click="datails(item.d_id)">查看并选择中标人</div>
					</div>
					<div class="hyfooter" v-if="item.status==2 && item.q_id==0 && item.quotes_count>0 && item.is_off==0 && item.end_text==4">
					    <div class="hyfooter2"  @click="Addemand(item.d_id,'2')" style="width:100%;">再次发布</div>
					</div>
					<div class="hyfooter" v-if="item.status==-1">
					    <div class="hyfooter3" @click="Addemand(item.d_id,'1')">重新发布</div>
					</div>
					<div class="hyfooter" v-if="item.status==2 && item.q_id !=0">
					    <div class="hyfooter2"  @click="Addemand(item.d_id,'2')">再次发布</div>
                        <div class="hyfooter1" @click="datails(item.d_id)">查看报价 {{item.quotes_count || '0'}} / {{item.quote_num}}</div>
					</div>
					<div class="hyfooter" v-if="item.status==2 && item.q_id==0 && item.quotes_count==0 && item.is_off==0" >
						<div class="hyfooter2" style="width:100%;"  @click="Addemand(item.d_id,'2')">
							再次发布
						</div>
					</div>
					<div class="hyfooter" v-if="item.status==2 && item.is_off==1" >
						<div class="hyfooter2"  style="width:100%;" @click="Addemand(item.d_id,'2')">
							再次发布
						</div>
					</div>
			   </div>
		</div>
	</div>
</template>

<script>
	export default {
	  name: 'HelloWorld',
	  data() {
	    return {
		   
	    }
	  },
	  props:{
		list:{}  
	  },
	  methods: {
		datails(e){
			const targetPath = '/demandHome/demandIndex/demanDatails?d_id='+e
			if (this.$route.path !== targetPath) {
				this.$router.push(targetPath)
			}
		},
		XQbj(e){
			const targetPath = '/demandHome/demandIndex/demanYaoqing?d_id='+e
			if (this.$route.path !== targetPath) {
				this.$router.push(targetPath)
			}
		},
		Addemand(id,type){
			const targetPath = '/demandHome/demandIndex/Addemand?d_id='+id+'&type='+type
			if (this.$route.path !== targetPath) {
				this.$router.push(targetPath)
			}
		}
	  },
	}
</script>

<style scoped>
	.xqlist{
			width:1200px;
			margin: 0 auto;
			margin-top:20px;
			display:flex;
	/* 		justify-content:space-between; */
			flex-wrap:wrap;
		}
		.xqlist>div:nth-child(3n){
			margin-right:0px;
		}
		.liebiao1{
			width:384px;
			height:230px;
			background: #FFFFFF;
			box-shadow: 0px 4px 4px 0px rgba(0,0,0,0.05);
			border-radius: 12px;
			margin-bottom:24px;
			margin-right:24px;
			padding:12px;
			box-sizing: border-box;
			cursor:pointer;
			transition: all 0.3s;
			position: relative;
		}
		.liebiao1:hover{
			transform: scale(1.03);
		}
		.title{
			width:100%;
			display:flex;
			justify-content:space-between;
		}
		.titleh4{
			width:260px;
			overflow: hidden; 
			text-overflow: ellipsis;
			white-space: nowrap;
		}
		.title span{
			color:#1E3A8A;
		}
		.titleTiem{
			width:100%;
			display:flex;
			align-items: center;
		}
		.titleTiem img{
			width:12px;
			height:12px;
			margin-right:5px;
		}
		.titleTiem span{
			font-weight: 400;
			font-size: 12px;
			color: #999999;
		}
		.hylist{
			width:100%;
			max-height:60px;
			overflow: hidden;
		}
		.hylist::-webkit-scrollbar {
		      display: none;           /* Chrome/Safari 隐藏滚动条 */
		}
		.hylist div>div{
	        padding:3px 5px;
			box-sizing: border-box;
			background: rgba(66,151,255,0.15);
			border-radius: 4px;
			float: left;
			font-weight: 500;
			font-size: 12px;
			white-space: nowrap;
			color: #4297FF;
			margin-right:6px;
			margin-top:6px;
		}
		.hybox{
			width:100%;
			height:60px;
			margin-top:5px;
			font-weight: 400;
			font-size: 14px;
			color: #666666;
			display: -webkit-box;
			-webkit-line-clamp: 3;
			-webkit-box-orient: vertical;
			overflow: hidden;
			word-wrap: break-word;
			text-overflow: ellipsis;
		}
		.hytiem{
			width:100%;
			display:flex;
			justify-content:space-between;
			align-items: center;
			margin-top:12px;
			background: #FFF8E5;
			border-radius: 4px 4px 4px 4px;
			padding:5px 8px;
			box-sizing: border-box;
		}
		.hytiem span{
			font-weight: 500;
			font-size: 14px;
			color: #FF5900;
		}
		.hyfooter{
			width:360px;
			display:flex;
			align-items:center;
			justify-content:space-between;
			position:absolute;
			bottom: 10px;
		}
		.hyfooter1{
			width: 174px;
			height: 32px;
			font-size: 14px;
			border-radius: 8px;
			background: rgba(30,58,138,0.15);
			color:#1E3A8A;
			display:flex;
			align-items:center;
			justify-content: center;
		}
		.hyfooter2{
			width: 174px;
			height: 32px;
			border-radius: 8px;
			font-size: 14px;
			background: #1E3A8A;
			color: #FFFFFF;
			display:flex;
			align-items:center;
			justify-content: center;
		}
		.hyfooter3{
			width:100%;
			height: 32px;
			font-size: 14px;
			border-radius: 8px;
			background: rgba(30,58,138,0.15);
			color:#1E3A8A;
			display:flex;
			align-items:center;
			justify-content: center;
		}
		.hyfooter4{
			width:100%;
			height: 32px;
			font-size: 14px;
			border-radius: 8px;
			background: #1E3A8A;
			color:#fff;
			display:flex;
			align-items:center;
			justify-content: center;
		}
		.kandu{
			width:100% !important;
		}
</style>